import { baseApi } from "@/api/baseApi";
import { BUSINESS_REPORTS_TAGS } from "./businessReports.constraints";
import type {
  SnapshotConversation,
  SnapshotConversationAskRequest,
  SnapshotConversationAskResponse,
  SnapshotConversationMessage,
} from "./grid/sidebar/qa/types";

const SNAPSHOT_CONVERSATION_TAG = BUSINESS_REPORTS_TAGS.SNAPSHOT_CONVERSATION_TAG;

export const snapshotConversationApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    askSnapshotConversation: builder.mutation<SnapshotConversationAskResponse, SnapshotConversationAskRequest>({
      invalidatesTags: [SNAPSHOT_CONVERSATION_TAG],
      query: data => ({
        url: "/pf-mainweb/business-reports/snapshot-conversation/ask",
        method: "POST",
        data,
      }),
    }),
    cancelSnapshotConversation: builder.mutation<void, { conversation_id: string }>({
      query: ({ conversation_id }) => ({
        url: `/pf-mainweb/business-reports/snapshot-conversation/conversations/${conversation_id}/cancel`,
        method: "POST",
      }),
    }),
    getSnapshotConversationMessages: builder.query<SnapshotConversationMessage[], { conversation_id: string }>({
      providesTags: [SNAPSHOT_CONVERSATION_TAG],
      query: ({ conversation_id }) => ({
        url: `/pf-mainweb/business-reports/snapshot-conversation/conversations/${conversation_id}/messages`,
      }),
    }),
    listSnapshotConversations: builder.query<
      SnapshotConversation[],
      { snapshot_collection_id: string; contract_family_projection?: boolean }
    >({
      providesTags: [SNAPSHOT_CONVERSATION_TAG],
      query: params => ({
        url: "/pf-mainweb/business-reports/snapshot-conversation/conversations",
        params,
      }),
    }),
    deleteSnapshotConversation: builder.mutation<void, { conversation_id: string }>({
      invalidatesTags: [SNAPSHOT_CONVERSATION_TAG],
      query: ({ conversation_id }) => ({
        url: `/pf-mainweb/business-reports/snapshot-conversation/conversations/${conversation_id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAskSnapshotConversationMutation: useSnapshotConversationAskMutation,
  useCancelSnapshotConversationMutation,
  useGetSnapshotConversationMessagesQuery: useSnapshotConversationMessagesQuery,
  useListSnapshotConversationsQuery: useSnapshotConversationListQuery,
  useDeleteSnapshotConversationMutation,
} = snapshotConversationApi;
